

























import Vue from 'vue'
import mixins from 'vue-typed-mixins';

import IsSmall from './mixins/IsSmall';
import PageList from './components/PageList.vue';
import MiniMenu from './components/MiniMenu.vue';

// Interfaces for component typechecking!
interface AppData {

}

interface AppMethods {

}

interface AppComputed {
	minimenu: boolean;
	classes: any;
}

interface AppProps {

}

export default mixins(IsSmall).extend<AppData, AppMethods, AppComputed, AppProps>({
	name: 'app',
	computed: {
		minimenu(){
			return this.$store.state.config.minimenu && !this.isSmall;
		},
		classes(){
			return {
				'kb-ia': true,
				'kb-ia--minimenu': this.minimenu 
			}
		}
	},
	components: {
		PageList,
		MiniMenu
	}
})
